
define('tpl!taoQtiItem/qtiCreator/tpl/toolbars/associableChoice.answer', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  return "checked=\"checked\"";
  }

  buffer += "<div class=\"mini-tlb\" data-edit=\"answer\" data-for=\"";
  if (helper = helpers.choiceSerial) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.choiceSerial); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n    <label class=\"tlb-button right\" title=\"This answer is correct\" data-edit=\"correct\">\n        <input \n            type=\"checkbox\" \n            data-role=\"correct\"\n            name=\"correct_";
  if (helper = helpers.interactionSerial) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.interactionSerial); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "[]\" \n            value=\"";
  if (helper = helpers.choiceIdentifier) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.choiceIdentifier); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" \n            ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.correct), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "/>\n        <span class=\"icon-checkbox\"></span>\n    </label>\n    <label class=\"tlb-button right\" title=\"Score of this answer\" data-edit=\"map\">\n        <input value=\"";
  if (helper = helpers.score) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.score); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" type=\"text\" data-role=\"score\" data-for=\"";
  if (helper = helpers.choiceIdentifier) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.choiceIdentifier); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" name=\"score\" class=\"score\" data-validate=\"$numeric\" data-validate-option=\"$allowEmpty; $event(type=keyup)\" />\n    </label>\n</div>";
  return buffer;
  });
});

